import React, { FC, useMemo, useState } from "react";
import { Plan } from "services/quotes/types";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import RatesBestPlanCard from "containers/retail/sections/energy-rates-3/RatesBestPlanCard";
import Spacer from "evcharging/components/Spacer";
import RatesTabs from "containers/retail/sections/energy-rates-3/RatesTabs";
import useI18n from "evcharging/hooks/useI18n";

interface RatesMobileBestPlansProps {
  bestPlans: Array<Plan | null>;
  handleSelectPlan(plan: Plan): void;
}

const RatesMobileBestPlans: FC<RatesMobileBestPlansProps> = ({ bestPlans, handleSelectPlan }) => {
  const theme = useTheme();
  const classes = createStyles(theme);
  const { t } = useI18n();

  const [value, setValue] = useState<number>(0);

  const tabs = useMemo(() => bestPlans.map((plan, index) => ({
    value: index,
    label: t('rates.n-mth', { n:plan?.term.value }),
  })), [bestPlans]);

  const onChange = (activeValue: number) => {
    setValue(activeValue);
  }

  return (
    <>
      <p className={classes.title}>{t('rates.select-term')}</p>
      <Spacer value={12} />
      <RatesTabs tabs={tabs} value={Number(value)} onChange={onChange} />
      <Spacer value={32} />
      {bestPlans[value] && (
        <RatesBestPlanCard plan={bestPlans[value]} onSelect={handleSelectPlan} />
      )}
    </>
  );
};

const createStyles = (theme: Theme) => (
  {
    paper: css({
      padding: 0,
      backgroundColor: 'white',
      boxShadow: '0 3px 5px rgba(0, 0, 0, .05)',
      borderRadius: 6,
    }),
    title: css({
      fontSize: 16,
      fontWeight: 700,
      color: '#000000',
    }),
  }
);

export default RatesMobileBestPlans;
